var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5H14C14 2.24 11.76 0 9 0C6.24 0 4 2.24 4 5H2C0.9 5 0.00999999 5.9 0.00999999 7L0 19C0 20.1 0.9 21 2 21H16C17.1 21 18 20.1 18 19V7C18 5.9 17.1 5 16 5ZM9 2C10.66 2 12 3.34 12 5H6C6 3.34 7.34 2 9 2ZM9 12C6.24 12 4 9.76 4 7H6C6 8.66 7.34 10 9 10C10.66 10 12 8.66 12 7H14C14 9.76 11.76 12 9 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentIcon);
export default __webpack_public_path__ + "static/media/contentIcon.415190c110592712be73e6370dcfeadf.svg";
export { ForwardRef as ReactComponent };